<template>
    <div
        id="creator_interactions_wrapper"
        class="border-border border-[1px] rounded-lg p-4"
    >
        <div class="flex items-center space-x-2">
            <p class="component-label">
                {{ $t('page.campaign.creator_interactions') }}
            </p>

            <div class="!ml-auto"></div>

            <p
                class="underline underline-offset-1 cursor-pointer text-brand-atosa text-xs"
                @click="is_show_create_target_dialog = true"
            >
                {{ $t('common.save') }}
            </p>

            <p
                class="underline underline-offset-1 cursor-pointer text-brand-atosa text-xs"
                @click="
                    show_list_save_target_table = !show_list_save_target_table
                "
            >
                {{
                    show_list_save_target_table
                        ? $t('common.close_list')
                        : $t('common.list')
                }}
            </p>

            <i
                class="el-icon-delete text-sm cursor-pointer"
                @click="handleUnselected"
            ></i>
        </div>

        <p class="component-text-desc mt-0 mb-3">
            {{ $t('page.campaign.desc_creator_interaction') }}
        </p>

        <treeselect
            v-model="action_category_ids"
            multiple
            :options="related_options"
            :placeholder="$t('input.placeholder.please_select')"
            :normalizer="normalizer_option"
            @input="handleChangeCreatorInteractions"
        />

        <el-table
            v-if="show_list_save_target_table"
            max-height="400"
            :data="list_custom_targets"
            class="mt-2"
        >
            <el-table-column width="260" :label="$t('common.name')">
                <template #default="scope">
                    <div class="flex space-x-2">
                        <div>
                            <el-tooltip
                                class="item"
                                effect="dark"
                                :content="scope.row.custom_target_name"
                                placement="top"
                            >
                                <p class="font-semibold truncate">
                                    {{ scope.row.custom_target_name }}
                                </p>
                            </el-tooltip>
                        </div>
                    </div>
                </template>
            </el-table-column>

            <el-table-column :label="$t('table.header.action')" min-width="160">
                <template slot-scope="scope">
                    <div>
                        <el-tooltip
                            class="item"
                            effect="dark"
                            :content="$t('common.add_to_target')"
                            placement="top"
                        >
                            <el-button
                                size="small"
                                icon="el-icon-plus"
                                @click="
                                    handleAddCustomTargetToList(
                                        scope.row.data_config
                                    )
                                "
                            >
                            </el-button>
                        </el-tooltip>

                        <el-tooltip
                            class="item"
                            effect="dark"
                            :content="$t('common.remove_to_target')"
                            placement="top"
                        >
                            <el-button
                                size="small"
                                icon="el-icon-minus"
                                @click="
                                    handleRemoveCustomTargetToList(
                                        scope.row.data_config
                                    )
                                "
                            >
                            </el-button>
                        </el-tooltip>

                        <el-tooltip
                            class="item"
                            effect="dark"
                            :content="$t('common.replate_to_target')"
                            placement="top"
                        >
                            <el-button
                                size="small"
                                icon="el-icon-aim"
                                @click="
                                    handleReplaceCustomTargetToList(
                                        scope.row.data_config
                                    )
                                "
                            >
                            </el-button>
                        </el-tooltip>
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                :label="$t('common.option')"
                fixed="right"
                width="100"
            >
                <template slot-scope="scope">
                    <el-button
                        type="danger"
                        size="small"
                        @click="handleDeleteCustomTarget(scope.row._id)"
                    >
                        {{ $t('button.delete') }}
                    </el-button>
                </template>
            </el-table-column>
        </el-table>

        <p class="component-label text-desc-text mt-3">
            {{ $t('page.campaign.desc_creator_interactions') }}
        </p>
        <div class="flex space-x-4">
            <el-checkbox
                v-model="checked_followed"
                @change="handleChangeSelected"
            >
                {{ $t('page.campaign.creator_interactions_followed') }}
            </el-checkbox>
            <el-checkbox
                v-model="checked_viewed_profile"
                @change="handleChangeSelected"
            >
                {{ $t('page.campaign.creator_interactions_viewed_profile') }}
            </el-checkbox>
        </div>

        <el-dialog
            :visible.sync="is_show_create_target_dialog"
            :close-on-click-modal="true"
            :append-to-body="true"
            width="480px"
        >
            <div slot="title">
                <p class="text-lg font-semibold">
                    {{ $t('button.save_custom_target') }}
                </p>
            </div>

            <div>
                <p class="component-label">
                    {{ $t('common.name') }}
                </p>
                <el-input
                    v-model="custom_target_name"
                    type="text"
                    size="small"
                    :placeholder="$t('input.placeholder.please_input')"
                >
                </el-input>
            </div>

            <template slot="footer">
                <div class="flex items-center justify-end mt-4">
                    <el-button
                        size="small"
                        @click="is_show_create_target_dialog = false"
                    >
                        {{ $t('button.close') }}
                    </el-button>

                    <el-button
                        :disabled="!custom_target_name"
                        type="primary"
                        size="small"
                        icon="el-icon-check"
                        @click="handleCreateCustomTarget"
                    >
                        {{ $t('button.confirm') }}
                    </el-button>
                </div>
            </template>
        </el-dialog>
    </div>
</template>

<script>
import Treeselect from '@riophae/vue-treeselect'
import {
    createCustomTarget,
    getCustomTargets,
    deleteCustomTarget
} from '@/services/atosa-tiktok-ads/custom-target'
import _ from 'lodash'

export default {
    components: {
        Treeselect
    },

    props: [
        'selected_item',
        'tiktok_account_id',
        'advertiser_id',
        'related_options'
    ],

    data() {
        return {
            normalizer_option(node) {
                return {
                    id: node.id,
                    label: node.label,
                    children: node.children
                }
            },
            list_custom_targets: [],
            custom_target_name: '',
            is_show_create_target_dialog: false,
            show_list_save_target_table: false,
            action_category_ids: [],
            checked_followed: false,
            checked_viewed_profile: false
        }
    },

    computed: {
        selected_item_in_line: {
            get: function () {
                return this.selected_item
            },
            set: function (val) {
                this.$emit('update:selected_item', val)
            }
        }
    },

    watch: {
        'selected_item.id'() {
            this.initData()
        },

        selected_item() {
            this.initData()
        },

        action_category_ids() {
            this.selected_item_in_line.extension.creator_interaction_names =
                this.action_category_ids.map((id) => {
                    const temp = this.related_options.find((i) => i.id === id)
                    if (temp) {
                        return temp.label
                    }
                    return id
                })
        }
    },

    mounted() {
        this.fetchCustomTargets()

        this.initData()
    },

    methods: {
        handleChangeCreatorInteractions() {
            this.handleChangeSelected()

            this.selected_item_in_line.actions =
                this.selected_item_in_line.actions.map((item) => {
                    if (item.action_scene === 'CREATOR_RELATED') {
                        if (item.action_category_ids.length > 0) {
                            return {
                                ...item,
                                video_user_actions: [
                                    'FOLLOWING',
                                    'VIEW_HOMEPAGE'
                                ]
                            }
                        }

                        return {
                            ...item,
                            video_user_actions: []
                        }
                    }

                    return item
                })

            this.initData()
        },

        initData() {
            this.action_category_ids = []
            this.checked_followed = false
            this.checked_viewed_profile = false

            if (this.selected_item_in_line?.actions.length > 0) {
                const action = this.selected_item_in_line.actions.find(
                    (item) => item.action_scene === 'CREATOR_RELATED'
                )

                if (!action) {
                    return
                }

                if (
                    action.video_user_actions.some(
                        (item) => item === 'FOLLOWING'
                    )
                ) {
                    this.checked_followed = true
                }

                if (
                    action.video_user_actions.some(
                        (item) => item === 'VIEW_HOMEPAGE'
                    )
                ) {
                    this.checked_viewed_profile = true
                }

                this.action_category_ids = action.action_category_ids
            }
        },

        handleUnselected() {
            this.action_category_ids = []
            this.checked_followed = false
            this.checked_viewed_profile = false

            this.handleChangeSelected()
        },

        async handleCreateCustomTarget() {
            if (!this.action_category_ids.length) {
                this.p__showNotify(
                    'warning',
                    this.$t(
                        'page.campaign.message_dont_choose_interest_keyword_ids'
                    )
                )
                return
            }

            if (!this.custom_target_name) {
                return
            }

            try {
                const data_config = JSON.stringify({
                    action_category_ids: this.action_category_ids
                })

                await createCustomTarget(this.tiktok_account_id, {
                    custom_target_name: this.custom_target_name,
                    custom_target_type: 'CREATOR_RELATED',
                    data_config
                })

                this.custom_target_name = ''
                this.is_show_create_target_dialog = false

                this.fetchCustomTargets()

                this.p__showNotify(
                    'success',
                    this.$t('common.create_data_success')
                )
            } catch (error) {
                console.error(error)
            }
        },

        async fetchCustomTargets() {
            try {
                const response = await getCustomTargets({
                    custom_target_name: '',
                    custom_target_type: 'CREATOR_RELATED',
                    tiktok_account_id: ''
                })

                this.list_custom_targets = response.data
            } catch (error) {
                console.error(error)
            }
        },

        async handleDeleteCustomTarget(ct_id) {
            try {
                await this.$confirm(
                    this.$t('common.delete_data_confirm'),
                    this.$t('common.warning'),
                    {
                        confirmButtonText: this.$t('button.confirm'),
                        cancelButtonText: this.$t('button.close'),
                        type: 'warning'
                    }
                )
            } catch (e) {
                return
            }

            try {
                await deleteCustomTarget(this.tiktok_account_id, {
                    custom_target_id: ct_id
                })

                this.fetchCustomTargets()

                this.p__showNotify(
                    'success',
                    this.$t('common.delete_data_success')
                )
            } catch (error) {
                console.error(error)
            }
        },

        handleChangeSelected() {
            if (
                !this.action_category_ids.length &&
                !this.checked_followed &&
                !this.checked_viewed_profile
            ) {
                this.selected_item_in_line.actions =
                    this.selected_item_in_line.actions.filter(
                        (ac) => ac.action_scene !== 'CREATOR_RELATED'
                    )

                return
            }

            const video_user_actions = []
            if (this.checked_followed) {
                video_user_actions.push('FOLLOWING')
            }
            if (this.checked_viewed_profile) {
                video_user_actions.push('VIEW_HOMEPAGE')
            }

            const action = {
                action_scene: 'CREATOR_RELATED',
                action_period: 0,
                action_category_ids: this.action_category_ids,
                video_user_actions
            }

            if (
                this.selected_item_in_line.actions.some(
                    (action) => action.action_scene === 'CREATOR_RELATED'
                )
            ) {
                this.selected_item_in_line.actions =
                    this.selected_item_in_line.actions.map((ac) => {
                        if (ac.action_scene === 'CREATOR_RELATED') {
                            return action
                        }

                        return ac
                    })
            } else {
                this.selected_item_in_line.actions = [
                    ...this.selected_item_in_line.actions,
                    action
                ]
            }
        },

        handleAddCustomTargetToList(data_config) {
            const temp = _.cloneDeep(JSON.parse(data_config))

            this.action_category_ids = this.p__removeDuplicateValueInArray([
                ...this.action_category_ids,
                ...temp.action_category_ids
            ])

            this.handleChangeSelected()
        },

        handleRemoveCustomTargetToList(data_config) {
            const temp = _.cloneDeep(JSON.parse(data_config))

            this.action_category_ids = [...this.action_category_ids].filter(
                (item) => !temp.action_category_ids.some((it) => it === item)
            )

            this.handleChangeSelected()
        },

        handleReplaceCustomTargetToList(data_config) {
            const temp = _.cloneDeep(JSON.parse(data_config))

            this.action_category_ids = [...temp.action_category_ids]

            this.handleChangeSelected()
        }
    }
}
</script>
